// extracted by mini-css-extract-plugin
export default {"container":"Checkout_container__+LRrE","phone":"Checkout_phone__PSP47","propayiframe":"Checkout_propayiframe__d3Kc6"};